/* eslint-disable react/prop-types */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@egaranti/components";

import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

function ConfirmationDialog({ open, onOpenChange, onConfirm }) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <CheckCircle2 className="h-6 w-6 text-green-600" />
          </div>
          <AlertDialogTitle className="text-center">
            {t(
              "extendedWarranty.add.confirmationMessage",
              "egaranti Plus paketini oluşturmak istediğinize emin misiniz?",
            )}
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="w-full">
            {t("common.cancel", "Vazgeç")}
          </AlertDialogCancel>
          <AlertDialogAction className="w-full" onClick={onConfirm}>
            {t("extendedWarranty.add.completeSale", "Satışı Tamamla")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmationDialog;
